import React from "react";
import { Time } from "./time";

// "Latest" on the item page: the newest entry from each AI source (rules, primary model, second opinion), decided
// by its created timestamp, is badged green and shown first; older entries are dimmed. A newer attempt that
// produced no entry (daily spend cap, provider error, benign text not sent: backend services/ai_attempts.py) is
// shown in amber next to the newest successful result, so a skipped re-ask is obvious.

const ts = (x) => { const t = Date.parse(x || ""); return Number.isNaN(t) ? -Infinity : t; };

// Newest by created time; equal timestamps are broken by id (the larger id wins), so the choice is stable.
export function newest(rows) {
  const later = (a, b) => ts(a.created_at) > ts(b.created_at)
    || (ts(a.created_at) === ts(b.created_at) && String(a.id ?? "") > String(b.id ?? ""));
  return (rows || []).reduce((best, r) => (!best || later(r, best) ? r : best), null);
}

// The latest entries first (in the order of `latestIds`), then the rest newest first.
export function latestFirst(rows, latestIds) {
  const ids = new Set(latestIds.filter(Boolean));
  const top = latestIds.filter(Boolean).map((id) => rows.find((r) => r.id === id)).filter(Boolean);
  const rest = rows.filter((r) => !ids.has(r.id)).sort((a, b) => ts(b.created_at) - ts(a.created_at));
  return [...top, ...rest];
}

// {word, reason, at} when the latest attempt for a source is newer than its latest result and did not succeed.
export function unsuccessfulAttempt(attempt, latest) {
  if (!attempt || attempt.status === "ok") return null;
  if (latest && ts(attempt.at) <= ts(latest.created_at)) return null;
  return { word: attempt.status === "error" ? "failed" : "skipped", reason: attempt.reason || attempt.status, at: attempt.at };
}

export function LatestBadge({ testid }) {
  return <span className="hs-badge hs-badge-safe" style={{ marginRight: 6 }} data-testid={testid}>Latest</span>;
}

export function AttemptNote({ attempt, testid }) {
  if (!attempt) return null;
  return (
    <span className="hs-badge hs-badge-warning" style={{ marginLeft: 6 }} data-testid={testid}>
      Latest attempt: {attempt.word} – {attempt.reason} (<Time value={attempt.at} />)
    </span>
  );
}

export const DIM_OLDER = { opacity: 0.7 };
